import { themr } from '@friendsofreactjs/react-css-themr';
import { compose } from 'recompose';
import intlEquipped from '../../../hocs/intlEquipped';

import InvoicesModal from './InvoicesModal';

export default compose(
    themr('InvoicesModal'),
    intlEquipped
)(InvoicesModal);
